module.exports = __webpack_public_path__ + "public/a3718cb14a6e17a0bacf0f3247e24531.svg";